<template>
  <div class="withdraw">
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row>
          <el-col :span="18">
            <el-form :inline="true" :model="searchCondition">
              <el-form-item label="选择商户">
                <el-input
                  placeholder="请输入商户信息"
                  v-model="searchCondition.companyname"
                  clearable
                >
                </el-input>
              </el-form-item>
              <!-- <el-form-item label="时间">
                <DatePicker @dataSearch="dataSearch" />
              </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="searchButton">查询</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <div class="withdraw-top-right">
              <span class="money">可提现金额：{{ withdrawmoney }}</span>
              <!-- <span class="top-right-text"></span> -->
              <el-button type="text" @click="Withdraw" style="color:#999999">提现</el-button>
            </div>
          </el-col>
        </el-row>

        <TreeTable
          :data="channelrebateList"
          :columns="columns"
          :loading="loadingStaus"
          ref="treeTable"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column prop="alias_msg" align="center" label="充值金额">
            <template slot-scope="scope">
              <el-tag type="warning">￥{{ scope.row.recharge_money }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="alias_msg" align="center" label="下发金额">
            <template slot-scope="scope">
              <el-tag type="warning">￥{{ scope.row.send_money }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="alias_msg" align="center" label="服务费">
            <template slot-scope="scope">
              <el-tag type="warning">￥{{ scope.row.tax_money }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="alias_msg" align="center" label="返佣金额">
            <template slot-scope="scope">
              <el-tag type="warning">￥{{ scope.row.commission_money }}</el-tag>
            </template>
          </el-table-column>
        </TreeTable>
      </div>
    </PageHeaderLayout>
    <WithdrawDialog :dialog-data="initRefundDialog" />
  </div>
</template>

<script>
// import PageHeaderLayout from "@/"
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import WithdrawDialog from "../../components/WithdrawDialog.vue";
import DatePicker from "@/components/DatePicker.vue";
import TreeTable from "../../components/TreeTable.vue";
export default {
  data() {
    return {
      // 搜索条件
      searchCondition: {
        companyname: "",
      },
      id: "",
      depth: 1,
      rechargeMoney: 0,
      sendMoney: 0,
      taxMoney: 0,
      commissionMoney: 0,
      rate: "一",
      withdrawmoney: "0.00",
      commercial_tenant: "",
      loadingStaus: false,
      channelrebateList: [],
      pagingData: {
        // 分页信息
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      children: [],
      // 提现对话封装数据
      initRefundDialog: {
        visible: false,
        width: "55%",
        loading: false,
        modal: true,
        confirmText: "发起提现",
        title: "发起提现",
        balanceMoney: "",
      },
      columns: [
        {
          title: "商户名称",
          header_align: "left",
          align: "left",
          value: "company_name",
        },
        {
          title: "税源地",
          header_align: "left",
          align: "left",
          value: "settlement_channel_name",
          operation: true, // 作为展开操作列
        },
        {
          title: "服务税率",
          value: "rate",
          header_align: "center",
          align: "center",
          // value_alias: "effect_uri",
        },
      ],
    };
  },
  components: {
    PageHeaderLayout,
    DatePicker,
    TreeTable,
    WithdrawDialog,
  },
  watch: {
    "$route.matched": function (n) {
      if (n.length === 2) {
        this.init();
      }
    },
    "examineRuleForm.status": function (val) {
      if (val) {
        this.examineDialogData.loading = false;
      } else {
        this.examineDialogData.loading = true;
      }
    },
  },

  methods: {
    Withdraw() {
      // this.initRefundDialog.visible = true;
      console.log(this.initRefundDialog.visible);
      // this.deliverData = {
      //   switchInfo: this.$store.state.switchInfo,
      //   userPhone: JSON.parse(localStorage.getItem('user_info')).mobile
      // }
    },
    // 可提现金额检查
    // async Withdrawmoney() {
    //   let result = await this.$api.withdrawmoney();
    //   this.withdrawmoney = result.withdraw_money;
    //   this.initRefundDialog.balanceMoney = result.check_money;
    //   console.log(result, "提现金额");
    // },
    //   查询条件

    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0];
      this.searchCondition.end_time = value[1];
    },

    // 搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.companyname) {
        condition.name = this.searchCondition.companyname;
      }

      return condition;
    },
    async init(type) {
      this.loadingStaus = true;
      let pagingInfo = this.$refs["treeTable"].getPagingInfo(type);
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let result = await this.$api.channelcommissionlist(searchCondition);
      // console.log(result.data.details, "分页数据");
      result.data.map((item) => {
        item.details.map((item) => {
          // item.recharge_money=(item.recharge_money).toFixed(2)
          //  console.log(((item.recharge_money)*1).toFixed(2) ,"字符串")
          // this.rate=item.rate
          item.rate = (item.rate * 1).toFixed(2) + "%";
          item.recharge_money = (item.recharge_money * 1).toFixed(2);
          item.commission_money = (item.commission_money * 1).toFixed(2);
          item.send_money = (item.send_money * 1).toFixed(2);
          item.tax_money = (item.tax_money * 1).toFixed(2);

          this.rechargeMoney += item.recharge_money * 1;
          this.commissionMoney += item.commission_money * 1;
          this.sendMoney += item.send_money * 1;
          this.taxMoney += item.tax_money * 1;
          item.depth = this.depth;
          item.company_name = null;
        });
        item.recharge_money = this.rechargeMoney.toFixed(2);
        item.send_money = this.sendMoney.toFixed(2);
        item.commission_money = this.commissionMoney.toFixed(2);
        item.tax_money = this.taxMoney.toFixed(2);
        item.rate = this.rate;
        // item.taxMoney = this.taxMoney;
        this.id = item.company_id;
        this.children = item.details;
        item.children = this.children;
        item.id = this.id;
      });
      console.log(result, "分页的东西");
      this.$nextTick(() => {
        this.channelrebateList = result.data;
      });
      // this.pagingData.total = result.total;
      // this.offset = pages.offset;
      this.loadingStaus = false;
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    //
  },
  mounted() {
    this.init();
    // this.Withdrawmoney();
  },
};
</script>

<style scoped>
.withdraw-top-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
}
.withdraw-top-right /deep/ .el-button {
  width: 50px;
}
.money {
  font-size: 15px;
}
</style>